// extracted by mini-css-extract-plugin
export default {"select":"SquareSelect_select__GgQiH"};